import { render, staticRenderFns } from "./shipyard-menu.svg.vue?vue&type=template&id=571d455b&"
import script from "./shipyard-menu.svg.vue?vue&type=script&lang=js&"
export * from "./shipyard-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports